<i class="social-dialog-close fas fa-times"
   (click)="closeSocialProfileDialog()"></i>
<i class="fas fa-users"></i>
<h1 transloco="resume.socialProfile.dialogTitle"
>Social Profiles</h1>
<p class="resume-social-dialog-summary"
   transloco="resume.socialProfile.summary"
>
  Add your social media profiles so others viewing your resume can see more about you.
</p>
<aero-form class="resume-social-dialog-container"
       submitButtonLabel="{{ 'saveButton' | transloco }}"
       [cancelButtonStyle]="cancelButtonStyle"
       [showCancelButton]="true"
       (onCancel)="closeSocialProfileDialog()"
       (onSubmit)="submitSocialProfiles()">

  <div class="social-profile-field">
    <img [ngClass]="{'social-disable-icon': resumeShareDetail.linkedin == null || resumeShareDetail.linkedin === '' }"
       [src]="'resources/images/bulb_resume_linkedin.svg' "/>
    <aero-input type="text"
          [id]="'bulbResumeProfileLinkedIn'"
          label="LinkedIn"
          name="linkedin"
          ngDefaultControl
          #linkedin="ngModel"
          [(ngModel)]="resumeShareDetail.linkedin"
          errorMessage="{{ 'resume.profile.linkedInErrorMessage' | transloco }}"
          [errors]="linkedin.errors"
          [bulbValidatePattern]="linkedinRegex"
          [name]="'linkedin'">
    </aero-input>
  </div>
  <div class="social-profile-field">
    <img [ngClass]="{'social-disable-icon': resumeShareDetail.facebook == null || resumeShareDetail.facebook === '' }"
       [src]="'resources/images/bulb_resume_facebook.svg' "/>
    <aero-input type="text"
          [id]="'bulbResumeProfileFacebook'"
          label="Facebook"
          name="Facebook"
          ngDefaultControl
          #facebook="ngModel"
          [(ngModel)]="resumeShareDetail.facebook"
          errorMessage="{{ 'resume.profile.facebookErrorMessage' | transloco }}"
          [errors]="facebook.errors"
          [bulbValidatePattern]="facebookRegex"
          [name]="'facebook'">
    </aero-input>
  </div>
  <div class="social-profile-field">
    <img [ngClass]="{'social-disable-icon': resumeShareDetail.instagram == null || resumeShareDetail.instagram === '' }"
       [src]="'resources/images/bulb_resume_instagram.svg' "/>
    <aero-input type="text"
          [id]="'bulbResumeProfileInstagram'"
          label="Instagram"
          name="Instagram"
          ngDefaultControl
          #instagram="ngModel"
          [(ngModel)]="resumeShareDetail.instagram"
          errorMessage="{{ 'resume.profile.instagramErrorMessage' | transloco }}"
          [bulbValidatePattern]="instagramRegex"
          [errors]="instagram.errors"
          [name]="'instagram'">
    </aero-input>
  </div>
  <!-- twitter|X -->
  <div class="social-profile-field">
    <img class="x-img" [ngClass]="{'social-disable-icon': resumeShareDetail.twitter == null || resumeShareDetail.twitter === '' }"
         [src]="'resources/images/social_x_black.svg' "/>
    <aero-input type="text"
                [id]="'bulbResumeProfileTwitter'"
                label="X"
                name="Twitter"
                ngDefaultControl
                #twitter="ngModel"
                [(ngModel)]="resumeShareDetail.twitter"
                errorMessage="{{ 'resume.profile.twitterErrorMessage' | transloco }}"
                [bulbValidatePattern]="twitterRegex"
                [errors]="twitter.errors"
                [name]="'twitter'">
    </aero-input>
  </div>
  <div class="social-profile-field">
    <img [ngClass]="{'social-disable-icon': resumeShareDetail.website == null || resumeShareDetail.website === '' }"
       [src]="'resources/images/bulb_resume_website.svg' "
       alt="{{ 'resume.socialProfile.website' | transloco }}"/>
    <aero-input type="text"
          [id]="'bulbResumeProfileOther'"
          label="{{ 'resume.socialProfile.website' | transloco }}"
          name="Other"
          ngDefaultControl
          #website="ngModel"
          [(ngModel)]="resumeShareDetail.website"
          errorMessage="{{ 'resume.profile.websiteErrorMessage' | transloco }}"
          [bulbValidatePattern]="websiteRegex"
          [errors]="website.errors"
          [name]="'website'">
    </aero-input>
  </div>
</aero-form>
